<template>
  <div class="page">
    <header>
      <img
        src="/static/images/header.png"
        :alt="specialCases.title"
      />
    </header>

    <div class="pageContent">
      <figure class="renderContainer">
        <img class="render"
          @load="$emit('imageLoaded', isLast)"
          :src="product.shareImgPath"
        />
      </figure>
      <div class="productSelectionContainer">
        <hr>
        <h4>{{ pageName }}</h4>
        <h6 v-if="product.product && product.product.modelNumber">
          Model {{ product.product.modelNumber }}
        </h6>
        <div v-if="layer" class="summary">
          <design-selection
            v-for="step of layer.steps ? layer.steps.filter(step => step.selected) : []"
            :class="{ active: step.active }"
            :key="step.name"
            :step="step"
          />
        </div>
      </div>
    </div>
    <footer>
      <small><strong>Please Note</strong>: {{ specialCases.disclaimer }}</small>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DesignSelection from '@/components/designReport/DesignSelection';

export default {
  name: 'design-page',
  props: {
    product: {
      type: Object,
      required: true,
    },
    layer: {
      type: Object,
      required: false,
    },
    pageName: {
      type: String,
      default: 'Product Summary',
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DesignSelection,
  },
  computed: mapState([
    'specialCases',
  ]),
};
</script>

<style lang="scss">
@page {
  size: Letter portrait;
  margin: 0;
}

.page {
  width: 8.5in;
  // do not specify height because print squishes to fit
  min-height: 6in; // over half of standard 11" page height, so each page gets it's own page
  padding: 0.5cm 1.2cm;
  margin: 1cm auto;
  background: white;
  size: 5.5in 8.5in;
  // cleanly split pages
  page-break-inside: avoid;
  page-break-after: always;

  @media print {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    color: initial;
  }

  @media not print {
    // this wrapper seems redundant, but it's so the PDF generator doesn't render these
    // (since it doesn't parse @media queries)
    border: 1px #D3D3D3 solid;
    box-shadow: 0 0 10px #ccc;
  }

  > header {
    width: 100%;
    height: 50px;
    text-align: center;

    img {
      display: block;
      margin: 0 auto;
      height: 38px;
      width: 45%;
    }
  }

  .pageContent {
    margin-top: 5px;

    .renderContainer {
      width: 100%;
      height: 100%;
      margin-top: 5px;
      text-align: center;

      .render {
        display: block;
        margin: 0 auto;
        max-width: 100%;
        max-height: 400px;
      }
    }

    .productSelectionContainer {
      width: 100%;
      height: 100%;
      margin-top: 15pt;

      hr {
        border-top: 1px solid black;
        width: 85%;
      }

      h4 {
        color: black;
        font-size: 26px;
        text-align: center;
        margin: 0;
      }

      h6 {
        text-align: center;
        margin-top: 5px;
      }

      .summary {
        margin-top: 15px;
        margin-bottom: 10px;

        h5 {
          font-size: 16px;
          background: #ccc !important;
          color: white !important;
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
        }

        .selectionBody {
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designReport/DesignPage.vue